/* tslint:disable */
/* eslint-disable */
/**
 * MG-DX Pharmacy Counselor API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.2.0
 * Contact: developers@mg-dx.co.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { tzDate } from "@mgdx-libs/dayjs";
import { exists, mapValues } from "../runtime";

export const GetAIAssistantReceptionViewResponseTypename = "GetAIAssistantReceptionViewResponse" as const;

/**
 *
 * @export
 * @interface GetAIAssistantReceptionViewResponse
 */
export interface GetAIAssistantReceptionViewResponse {
  /**
   *
   * @type {number}
   * @memberof GetAIAssistantReceptionViewResponse
   */
  counselingAiAssistantReceptionId: number;
  /**
   *
   * @type {number}
   * @memberof GetAIAssistantReceptionViewResponse
   */
  id: number;
  /**
   *
   * @type {object}
   * @memberof GetAIAssistantReceptionViewResponse
   */
  receptionView?: object;
  /**
   * Resource type name
   * @type {string}
   * @memberof GetAIAssistantReceptionViewResponse
   */
  readonly __typename?: string;
}

export function GetAIAssistantReceptionViewResponseFromJSON(json: any): GetAIAssistantReceptionViewResponse {
  return GetAIAssistantReceptionViewResponseFromJSONTyped(json, false);
}

export function GetAIAssistantReceptionViewResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): GetAIAssistantReceptionViewResponse {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    __typename: GetAIAssistantReceptionViewResponseTypename,

    counselingAiAssistantReceptionId: json["counseling_ai_assistant_reception_id"],
    id: json["id"],
    receptionView: !exists(json, "reception_view") ? undefined : json["reception_view"],
  };
}

export function GetAIAssistantReceptionViewResponseToJSON(object?: GetAIAssistantReceptionViewResponse | null): any {
  if (object === undefined) {
    return undefined;
  }
  if (object === null) {
    return null;
  }
  const { __typename, ...value } = object;
  return {
    counseling_ai_assistant_reception_id: value.counselingAiAssistantReceptionId,
    id: value.id,
    reception_view: value.receptionView,
  };
}
